__turbopack_context__.v({
  "big": "PyKJEq_big",
  "blue": "PyKJEq_blue",
  "exiting": "PyKJEq_exiting",
  "fadeOut": "PyKJEq_fadeOut",
  "green": "PyKJEq_green",
  "line": "PyKJEq_line",
  "pop": "PyKJEq_pop",
  "popIn": "PyKJEq_popIn",
  "popOut": "PyKJEq_popOut",
  "red": "PyKJEq_red",
  "yellow": "PyKJEq_yellow",
});
